
export default [
  {
    name:"TCashFinance",
    path: '/TCashFinance',
    component: () => import('@/views/ustnFinance/index'),
    meta: { title: 'Brief', noCache: false, affix: false},
    children:[
      {
        path: '',
        redirect:"lending"
      },
      {
        name:"exchange",
        path: 'exchange',
        component: () => import('@/views/ustnFinance/exchange/index.vue'),
        meta: { title: 'exchange', noCache: false, affix: false},
      },
      {
        name:"deposit",
        path: 'deposit',
        component: () => import('@/views/ustnFinance/deposit/index.vue'),
        meta: { title: 'deposit', noCache: false, affix: false},
      },
      {
        name:"lending",
        path: 'lending',
        component: () => import('@/views/ustnFinance/lending/index.vue'),
        meta: { title: 'lending', noCache: false, affix: false},
      },
      {
        name:"auction",
        path: 'auction',
        component: () => import('@/views/ustnFinance/auction/index.vue'),
        meta: { title: 'auction', noCache: false, affix: false},
      },
      {
        name:"profile",
        path: 'profile',
        component: () => import('@/views/ustnFinance/profile/index.vue'),
        meta: { title: 'profile', noCache: false, affix: false},
      }
    ]
  },
  {
    name:"placeBid",
    path: 'auction/placeBid',
    component: () => import('@/views/ustnFinance/auction/placeBid/index.vue'),
    meta: { title: 'placeBid', noCache: false, affix: false},
  },
  {
    name:"placeBidRecord",
    path: 'auction/placeBid/record',
    hidden:true,
    component: () => import('@/views/ustnFinance/auction/placeBid/record/index.vue'),
    meta: { title: 'placeBidRecord', noCache: false, affix: false},
  },
  {
    name:"placeBidDetail",
    path: 'auction/placeBid/detail',
    hidden:true,
    component: () => import('@/views/ustnFinance/auction/placeBid/detail/index.vue'),
    meta: { title: 'placeBidDetail', noCache: false, affix: false},
  },
  {
    name:"lendingDetail",
    path: '/ustnFinance/lending/detail',
    hidden:true,
    component: () => import('@/views/ustnFinance/lending/detailDetail.vue'),
    meta: { title: 'lendingDetail', noCache: false, affix: false},
  },
  {
    name:"lendingDetail",
    path: '/TCashFinance/lending/detail',
    hidden:true,
    component: () => import('@/views/ustnFinance/lending/detailDetail.vue'),
    meta: { title: 'lendingDetail', noCache: false, affix: false},
  },
]
